<template>
  <v-dialog
    width="800"
    persistent
    v-model="dialog"
  >
    <v-card>
      <v-card-title>
        {{ modalTitle }}
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-0">
        <v-tabs
          v-model="activeTab"
          background-color="deep-purple lighten-5"
          light
          centered
          slider-color="primary"
        >
          <v-tab v-for="tab in tabs" :key="tab.key" :disabled="!tab.enabled">
            {{ tab.label }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="activeTab">
          <v-tab-item :key="0">
            <equipment-infos
              :equipment="equipment"
              :updatable="updatable"
              @close="dialog = false"
              @created="equipment => $emit(`created`, equipment)"
              @updated="equipment => $emit(`updated`, equipment)"
              @removed="equipment => $emit(`removed`, equipment)"
            />
          </v-tab-item>
          <v-tab-item :key="1" v-if="!isNew">
            <equipment-notes
              :equipment="equipment"
              :updatable="updatable"
              @noteAdded="dialog = false"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import EquipmentInfos from '@/components/Equipments/Modal/Infos.vue';
import EquipmentNotes from '@/components/Equipments/Modal/Notes.vue';
import { mapState } from 'vuex';

export default {
  props: {
    updatable: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  data: () => ({
    isOpned: true,
    activeTab: 0,
  }),

  computed: {
    ...mapState(`ui/equipmentModal`, [
      `equipment`,
    ]),
    dialog: {
      get() { return this.isOpned; },
      set(isOpened) {
        this.isOpned = isOpened;
        if (!isOpened) {
          this.$emit(`close`);
        }
      },
    },
    tabs() {
      const tabs = [
        { key: 0, label: `Infos`, enabled: true },
        { key: 1, label: `Notes`, enabled: !this.isNew },
        // { key: 2, label: `Fichiers` },
      ];
      // if (this.areClientTagsActivated || this.areMakerTagsActivated) {
      //   tabs.push({ key: 1, label: `Tags` });
      // }

      return tabs;
    },
    isNew() { return this.equipment === null; },
    modalTitle() { return this.isNew ? `Nouvel équipement` : `Détails d'un équipement`; },
  },

  methods: {
    created() {},
    updated() {},
  },

  components: {
    EquipmentInfos,
    EquipmentNotes,
  },
};
</script>

<style lang="scss">
</style>
